import { useEffect } from "react";
import { Outlet, useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, type SupportedLocale } from "../../translations/config";

/**
 * LocaleLayout
 *
 * Layout route that reads `$locale` from URL params,
 * validates it against SUPPORTED_LOCALES, and calls
 * i18n.changeLanguage(locale) so all child routes render
 * in the correct language.
 */
export function LocaleLayout() {
  const { locale } = useParams({ strict: false }) as { locale?: string };
  const { i18n } = useTranslation();

  useEffect(() => {
    if (locale && (SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
      i18n.changeLanguage(locale as SupportedLocale);
    }
  }, [locale, i18n]);

  return <Outlet />;
}
